module.exports = __webpack_public_path__ + "img/active-status.b2b4a60f.svg";